import { FieldAngle } from 'blockly'

FieldAngle.WRAP = 180;
